var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChartZero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 40,
    viewBox: "0 0 82 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.4723 20.1357C68.6733 15.8478 75.8387 20.1357 81 22.2949V40H1V19.0561C2.6288 20.8555 11.8141 23.916 19.5683 21.2153C27.3224 18.5147 29.5767 17.4367 37.1292 19.0562C43.9463 20.5179 50.2713 24.4236 59.4723 20.1357Z",
    fill: "#F2F4F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4723 20.1357C68.6733 15.8478 75.8387 20.1357 81 22.2949V40H1V19.0561C2.6288 20.8555 11.8141 23.916 19.5683 21.2153C27.3224 18.5147 29.5767 17.4367 37.1292 19.0562C43.9463 20.5179 50.2713 24.4236 59.4723 20.1357Z",
    fill: "url(#paint0_linear_8494_13430)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81 21.2949C75.8387 19.1357 68.6733 14.8478 59.4723 19.1357C50.2713 23.4236 43.9463 19.5179 37.1292 18.0562C29.5767 16.4367 27.3224 17.5147 19.5683 20.2153C11.8141 22.916 2.6288 19.8555 1 18.0561",
    stroke: "#B3B3B7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8494_13430",
    x1: 41,
    y1: 18.2949,
    x2: 41,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.641167,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartZero);
export default __webpack_public_path__ + "static/media/chart-zero.84a8a84c582cd7b4e990afb532b2de92.svg";
export { ForwardRef as ReactComponent };